export const META_PIXEL_ID = '3601101066711360'

const PRODUCT = {
  content_name: 'Anfitrión Pro 365',
  content_type: 'product',
  content_ids: ['anfitrion-pro-365'],
  value: 14.99,
  currency: 'USD',
}

/** Minimum time between two identical events (guards double clicks). */
const DEDUPE_WINDOW = 2000

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
    __metaPixelInit?: boolean
    __metaPixelPageView?: boolean
    __metaPixelLastEvents?: Record<string, number>
  }
}

const eventId = (name: string): string =>
  `${name}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

/** Injects Meta's official base code exactly once. */
function loadPixel(): void {
  if (window.fbq) return

  /* eslint-disable */
  const n: any = function (...args: unknown[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  /* eslint-enable */

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

/**
 * Loads + initializes the pixel and fires PageView and ViewContent exactly
 * once per page load. Safe to call many times (React re-mounts included).
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return

  if (!window.__metaPixelInit) {
    loadPixel()
    window.fbq('init', META_PIXEL_ID)
    window.__metaPixelInit = true
  }

  if (!window.__metaPixelPageView) {
    window.__metaPixelPageView = true
    window.fbq('track', 'PageView', {}, { eventID: eventId('PageView') })
    window.fbq('track', 'ViewContent', PRODUCT, {
      eventID: eventId('ViewContent'),
    })
  }
}

/**
 * Fires a standard Meta event. Initializes the pixel first if needed and
 * ignores the same event repeated inside the dedupe window.
 */
export function trackMetaEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return

  initMetaPixel()

  const now = Date.now()
  const last = window.__metaPixelLastEvents ?? {}
  if (last[event] && now - last[event] < DEDUPE_WINDOW) return
  last[event] = now
  window.__metaPixelLastEvents = last

  window.fbq('track', event, params, { eventID: eventId(event) })
}

/** Fires InitiateCheckout right before sending the user to the checkout. */
export function trackInitiateCheckout(source: string): void {
  trackMetaEvent('InitiateCheckout', { ...PRODUCT, content_category: source })
}

/** Fires Lead for in-page CTAs that only scroll to the pricing block. */
export function trackLead(source: string): void {
  trackMetaEvent('Lead', { ...PRODUCT, content_category: source })
}
